/**
 * the type of other spirits
 */
export type OtherSpiritType =
  | 'FRUIT_PORNACE_DISTILLATE'
  | 'RAISIN_SPIRIT_OR_RAISIN_BRANDY'
  | 'CIDER_AND_PERRY_SPIRIT'
  | 'HONEY_DISTILLATE'
  | 'HEFEBRAND_OR_SWEEP_SPIRIT'
  | 'BIERBRAND_OR_EAU_DE_VIEW_DE_BIERE'
  | 'JERUSALEM_ARTICHOKE_OR_ARTICHOKE_LIQUEUR'
  | 'DISTILLATE_OBTAINED_BY_EXTRACTION_AND_DISTILLATION'
  | 'GEIST'
  | 'TARNIC_SPIRIT'
  | 'SPIRITS_FLAVORED_WITH_JUNIPER'
  | 'CUMIN_FLAVORED_SPIRITS'
  | 'AQUAVIT'
  | 'ANISE_FLAVORED_SPIRITS'
  | 'PASTIS'
  | 'PASTIS_DE_MARSEILLE'
  | 'ANISE'
  | 'DESTILLED_ANISE'
  | 'OUZO'
  | 'MISTRA'
  | 'VAKAVEA_GLOGI_OR_SPRITGLOGG'
  | 'BERENBURG_OR_BEERENBURG'
  | 'HONEY_NECTAR_OR_MEAD'
  | 'OTHER';

export const OtherSpiritType = {
  FruitPornaceDistillate: 'FRUIT_PORNACE_DISTILLATE' as OtherSpiritType,
  RaisinSpiritOrRaisinBrandy:
    'RAISIN_SPIRIT_OR_RAISIN_BRANDY' as OtherSpiritType,
  CiderAndPerrySpirit: 'CIDER_AND_PERRY_SPIRIT' as OtherSpiritType,
  HoneyDistillate: 'HONEY_DISTILLATE' as OtherSpiritType,
  HefebrandOrSweepSpirit: 'HEFEBRAND_OR_SWEEP_SPIRIT' as OtherSpiritType,
  BierbrandOrEauDeViewDeBiere:
    'BIERBRAND_OR_EAU_DE_VIEW_DE_BIERE' as OtherSpiritType,
  JerusalemArtichokeOrArtichokeLiqueur:
    'JERUSALEM_ARTICHOKE_OR_ARTICHOKE_LIQUEUR' as OtherSpiritType,
  DistillateObtainedByExtractionAndDistillation:
    'DISTILLATE_OBTAINED_BY_EXTRACTION_AND_DISTILLATION' as OtherSpiritType,
  Geist: 'GEIST' as OtherSpiritType,
  TarnicSpirit: 'TARNIC_SPIRIT' as OtherSpiritType,
  SpiritsFlavoredWithJuniper:
    'SPIRITS_FLAVORED_WITH_JUNIPER' as OtherSpiritType,
  CuminFlavoredSpirits: 'CUMIN_FLAVORED_SPIRITS' as OtherSpiritType,
  Aquavit: 'AQUAVIT' as OtherSpiritType,
  AniseFlavoredSpirits: 'ANISE_FLAVORED_SPIRITS' as OtherSpiritType,
  Pastis: 'PASTIS' as OtherSpiritType,
  PastisDeMarseille: 'PASTIS_DE_MARSEILLE' as OtherSpiritType,
  Anise: 'ANISE' as OtherSpiritType,
  DestilledAnise: 'DESTILLED_ANISE' as OtherSpiritType,
  Ouzo: 'OUZO' as OtherSpiritType,
  Mistra: 'MISTRA' as OtherSpiritType,
  VakaveaGlogiOrSpritglogg: 'VAKAVEA_GLOGI_OR_SPRITGLOGG' as OtherSpiritType,
  BerenburgOrBeerenburg: 'BERENBURG_OR_BEERENBURG' as OtherSpiritType,
  HoneyNectarOrMead: 'HONEY_NECTAR_OR_MEAD' as OtherSpiritType,
  Other: 'OTHER' as OtherSpiritType,
};
